module.exports = __webpack_public_path__ + "static/colornotationpeek-f882a22d7f9342844a2ada5d6f1675c4.png";